export default __webpack_public_path__ + "static/Sailec-Bold-17681e13eb6353a940903dd6c1a5d785.woff";